import { useAuthStatus } from '@jotta/auth-client/useAuthStatus'
import { useGetPath } from '@jotta/grpc-connect-client/useGetPath'
import type { PathItemObject } from '@jotta/types/Files'
import SvgWarningCircle from '@jotta/ui/SvgWarningCircle'
import { cn } from '@jotta/utils/css'
import { Trans } from '@lingui/macro'
import Debug from 'debug'
import { useState } from 'react'
import Spinner from '../../../../ui/src/Elements/Spinner/Spinner'

const debug = Debug('jotta:ui:FileViewAudio')

export function FileViewAudio({
  file,
  token,
}: {
  file: PathItemObject
  token?: string
}) {
  const [error, setError] = useState(false)
  const [ready, setReady] = useState(false)
  const { data: auth } = useAuthStatus()
  const accessToken = token || auth?.accessToken

  const { data, isFetched } = useGetPath({
    variables: { path: file.path },
    callOptions: accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined,
  })
  let downloadLink = data?.pathItem?.downloadLink

  if (downloadLink && accessToken) {
    downloadLink = `${downloadLink}?access_token=${accessToken}`
  }

  const isError = error || (isFetched && !downloadLink)
  const isLoading = !isFetched || (!isError && !ready)

  return (
    <div className="mx-auto self-center">
      {isLoading && (
        <div className="absolute left-0 top-0 flex h-full w-full">
          <Spinner className="mx-auto self-center" />
        </div>
      )}
      {!isError && downloadLink && (
        <audio
          controls
          onError={() => {
            setError(true)
          }}
          className={cn({ invisible: !ready })}
          onCanPlay={() => setReady(true)}
        >
          <source src={downloadLink} />
        </audio>
      )}
      {isError && (
        <div className="flex gap-2 text-2xl text-gray-300">
          <SvgWarningCircle width="1.4em" />
          <span>
            <Trans>There was a problem loading the file</Trans>
          </span>
        </div>
      )}
    </div>
  )
}
